module.exports = __webpack_public_path__ + "img/nav05.f86a858f.png";